<lib-schedule
	[scheduleType]="'workout'"
	[scheduleItemGroups]="scheduleItemGroups()"
	[scheduleContainers]="scheduleContainers()"
	[scheduleTitle]="scheduleTitle()"
	[customSchedules]="customSchedules()"
	[defaultSchedules]="defaultSchedules()"
	[routeMap]="routeMap"
	(saveSchedule)="handleSaveSchedule($event)"
	(saveScheduleAsTemplate)="handleSaveScheduleAsTemplate($event)"
	(deleteSchedule)="handleDeleteSchedule($event)"
	[enableEdit]="enableEdit()"
></lib-schedule>
